import React, { Component } from 'react';
import envconfig from '../../envconfig/envconfig';
import { Link } from 'react-router-dom';

class ContactMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tips: '',
      isClick: true, // true 可点击，false 不可点击
      userName: '',
      companyName: '',
      phone: '',
      email: '',
      title: '',
      content: '',
      fileInput: React.createRef(),
      isFile: '添付ファイル',
      isAgreed: false, // 隐私政策同意状态
    };
  }

  // 页面加载时初始化 localStorage（仅记录时间，不强制计数）
  componentDidMount() {
    let flag = localStorage.getItem('sendCount');
    if (!flag) {
      // 初始化：只存一个过期时间，用于未来可能的清理或重置
      const nextHour = new Date().getTime() + 3600000; // 1小时后
      localStorage.setItem('sendCount', JSON.stringify({ time: nextHour }));
    }
  }

  // 输入处理
  handleUserNameChange = (event) => {
    this.setState({ userName: event.target.value.replace(/(^\s*)/g, '') });
  };

  handleCompanyNameChange = (event) => {
    this.setState({ companyName: event.target.value.replace(/(^\s*)/g, '') });
  };

  handlePhoneChange = (event) => {
    this.setState({ phone: event.target.value.replace(/(^\s*)/g, '') });
  };

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value.replace(/(^\s*)/g, '') });
  };

  handleTitleChange = (event) => {
    this.setState({ title: event.target.value.replace(/(^\s*)/g, '') });
  };

  handleContentChange = (event) => {
    this.setState({ content: event.target.value.replace(/(^\s*)/g, '') });
  };

  // 处理隐私政策同意复选框
  handleAgreeChange = () => {
    this.setState((prevState) => ({ isAgreed: !prevState.isAgreed }));
  };

  // 文件选择后更新显示名称
  checkFile = () => {
    const file = this.state.fileInput.current ? this.state.fileInput.current.files[0] : null;
    if (file) {
      this.setState({ isFile: file.name });
    } else {
      this.setState({ isFile: '添付ファイル' });
    }
  };

  // 提交表单：打开邮件客户端
  handleSubmit = () => {
    // 检查是否同意隐私政策
    if (!this.state.isAgreed) {
      alert('個人情報のお取扱いに関する同意事項に同意してください');
      return;
    }

    const { userName, companyName, phone, email, title, content } = this.state;

    // 必填项验证
    if (!userName || !email || !title) {
      alert('氏名、メールアドレス、件名は必須です。');
      return;
    }

    // 邮箱格式验证
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('有効なメールアドレスを入力してください');
      return;
    }

    // 构建邮件正文
    let mailtoBody = '';
    mailtoBody += `氏名: ${encodeURIComponent(userName)}\n`;
    mailtoBody += `所属会社: ${encodeURIComponent(companyName || 'なし')}\n`;
    mailtoBody += `電話番号: ${encodeURIComponent(phone || 'なし')}\n`;
    mailtoBody += `メールアドレス: ${encodeURIComponent(email)}\n\n`;
    mailtoBody += `内容:\n${encodeURIComponent(content || 'なし')}`;

    // 提醒用户手动添加附件
    const fileInput = this.state.fileInput.current;
    if (fileInput && fileInput.files.length > 0) {
      const fileName = fileInput.files[0].name;
      mailtoBody += `\n\n※ 添付ファイル: 「${fileName}」をメールに手動で追加してください。`;
    }

    // 构造 mailto 链接
    const subject = encodeURIComponent(title);
    const body = mailtoBody;
    const mailtoLink = `mailto:info@sunflower-soft.com?subject=${subject}&body=${body}`;

    // 打开邮件客户端
    window.location.href = mailtoLink;

    // 禁用按钮 10 秒，防止用户反复点击造成困扰
    this.setState({ isClick: false });

    setTimeout(() => {
      this.setState({ isClick: true });
    }, 10000); // 10秒冷却

    // 延迟提示（防止被跳转打断）
    setTimeout(() => {
      alert('メールクライアントが開きます。\n添付ファイルがある場合は、手動で追加して送信してください。');
    }, 100);
  };

  render() {
    // 安全获取文件输入和文件数量
    const fileInput = this.state.fileInput.current;
    const hasFile = fileInput && fileInput.files.length > 0;

    return (
      <div className="contact main layui-container">
        {/* 左侧联系信息 */}
        <div className="layui-col-md5 co1">
          <h2>連絡します</h2>

          <div className="layui-row addrow">
            <div className="layui-col-xs2 layui-col-md2">
              <i className="layui-icon layui-inline icon">&#xe68e;</i>
            </div>
            <div className="layui-col-xs10 layui-col-md10">
              <h3>所在地</h3>
              <p>東京都千代田区神田須田町１－２８－４　日宝神田ビル10階</p >
            </div>
          </div>

          <div className="layui-row emailrow">
            <div className="layui-col-xs2 layui-col-md2">
              <i className="layui-icon layui-inline icon">&#xe611;</i>
            </div>
            <div className="layui-col-xs10 layui-col-md10">
              <h3>メール</h3>
              <p>info@sunflower-soft.com</p >
            </div>
          </div>

          <div className="layui-row phonerow">
            <div className="layui-col-xs2 layui-col-md2">
              <i className="layui-icon layui-inline icon">&#xe678;</i>
            </div>
            <div className="layui-col-xs10 layui-col-md10">
              <h3>電話番号</h3>
              <p>03-3525-8872</p >
            </div>
          </div>

          <div className="layui-row phonerow">
            <div className="layui-col-xs2 layui-col-md2">
              <i className="layui-icon layui-inline icon">&#xe66d;</i>
            </div>
            <div className="layui-col-xs10 layui-col-md10">
              <h3>FAX番号</h3>
              <p>03-3525-8713</p >
            </div>
          </div>
        </div>

        {/* 右侧表单 */}
        <div className="layui-col-md7 co2">
          <input
            type="text"
            onChange={this.handleUserNameChange}
            placeholder="氏名を入力してください！"
            value={this.state.userName}
          />
          <input
            type="text"
            value={this.state.companyName}
            onChange={this.handleCompanyNameChange}
            placeholder="所属会社を入力してください！"
          />
          <input
            type="text"
            value={this.state.phone}
            onChange={this.handlePhoneChange}
            placeholder="電話番号を入力してください！"
          />
          <input
            type="text"
            value={this.state.email}
            onChange={this.handleEmailChange}
            placeholder="メールアドレスを入力してください！"
          />
          <input
            type="text"
            value={this.state.title}
            onChange={this.handleTitleChange}
            placeholder="件名を入力してください！"
            className="inptitle"
          />
          <textarea
            name="desc"
            value={this.state.content}
            onChange={this.handleContentChange}
            placeholder="内容を入力してください！"
          />

          {/* 文件上传 */}
          <input
            type="file"
            name="file"
            id="upFileInput"
            className="file"
            ref={this.state.fileInput}
            onChange={this.checkFile}
          />
          <div>
            <label htmlFor="upFileInput" className="filelabel">
              {this.state.isFile}
            </label>
            <label htmlFor="upFileInput" className="layui-icon upfilelabel">&#xe67c;</label>
          </div>

          {/* 显示附件提醒 */}
          {hasFile && (
            <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>
              ※ ファイルは自動で送信されません。メール送信時に手動で添付してください。
            </div>
          )}

          {/* 隐私政策同意区域 */}
          <div className="layui-col-md12">
            <div className="layui-col-md12-policy">
              {/* 修改：添加 target="_blank" 和 rel 属性，在新标签页打开 */}
              <Link 
                to="/privacyInfoUsagePolicy" 
                className="layui-col-md12-policy-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                個人情報のお取扱いに関する同意事項
              </Link>
              をご確認いただき、同意される方は「同意する」をチェックして、「送信」を押してください。
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '5px',
              }}
            >
              <div
                style={{
                  width: '15px',
                  height: '15px',
                  border: '2px solid #2db5a3',
                  borderRadius: '3px',
                  backgroundColor: this.state.isAgreed ? '#2db5a3' : 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={this.handleAgreeChange}
              >
                {this.state.isAgreed && (
                  <span style={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}>✓</span>
                )}
              </div>
              <span style={{ marginLeft: '8px', fontSize: '14px' }}>同意する</span>
            </div>
          </div>

          {/* 提交按钮 */}
          <button
            onClick={this.handleSubmit}
            disabled={!this.state.isClick || !this.state.isAgreed}
            className="but"
            style={{
              marginTop: '20px',
              opacity: !this.state.isClick || !this.state.isAgreed ? '0.6' : '1',
              backgroundColor: !this.state.isClick || !this.state.isAgreed ? '#ccc' : '#2db5a3',
            }}
          >
            {this.state.isClick ? 'すぐに送信します' : '送信中...'}
            <i className="layui-icon">&#xe609;</i>
          </button>
        </div>
      </div>
    );
  }
}

export default ContactMain;